import { useUiStore } from '~/stores/ui'

export function useToast() {
  const ui = useUiStore()

  const showToast = (content: string, color: 'success' | 'danger' | 'warning' | 'info' = 'success', title?: string) => {
    const toast = {
      title,
      content,
      color,
      id: Date.now()
    }
    
    ui.toasts.push(toast)

    setTimeout(() => {
      const index = ui.toasts.findIndex(t => t.id === toast.id)
      if (index > -1) {
        ui.toasts.splice(index, 1)
      }
    }, 5000)
  }

  const removeToast = (id: number) => {
    const index = ui.toasts.findIndex(t => t.id === id)
    if (index > -1) {
      ui.toasts.splice(index, 1)
    }
  }

  const clearToasts = () => {
    ui.toasts = []
  }

  return {
    toasts: computed(() => ui.toasts),
    showToast,
    removeToast,
    clearToasts
  }
} 